import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../settings/components/Form";

/*
const getCharacterValidationError = (string) => {
    return `Your password must have at least 1 ${string} character`;
  };

const schema = yup.object({
    password: yup.string()
        .required("Please enter a password")
        // check minimum characters
        .min(8, "Password must have at least 8 characters")
        // different error messages for different requirements
        .matches(/[0-9]/, getCharacterValidationError("digit"))
        .matches(/[a-z]/, getCharacterValidationError("lowercase"))
        .matches(/[A-Z]/, getCharacterValidationError("uppercase")),
        confirmPassword: yup.string()
        .required("Please re-type your password")
        // use oneOf to match one of the values inside the array.
        // use "ref" to get the value of passwrod.
        .oneOf([yup.ref("password")], "Passwords do not match")
});

const ResetPw = () => {
    let {id, code} = useParams();

    const navigate = useNavigate();

    const {
    register,
    handleSubmit,
    formState: { errors }, control
    } = useForm({
        resolver: yupResolver(schema)
    });

    const onFormSubmit = async (data) => {
        const body = JSON.stringify({
            id: id,
            code: code,
            pw: data.password
        });
        console.log(body);
        const response = await fetch(
            `${process.env.REACT_APP_USER_API_URL}/users/reset-pw`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: body
            }
        );
        if (response.ok) {
            navigate("/");
        }
    }

    const onErrors = (errors) => console.error(errors);

    return (
        <div className="flex content-center">
            <form className="flex flex-col space-y-3" onSubmit={handleSubmit(onFormSubmit, onErrors)}>
                <div>
                    <input
                        type="password"
                        autoComplete="off"
                        placeholder="Select password"
                        className="input input-bordered input-accent"
                        name="password"
                        {...register("password")}
                    />
                    {errors?.password && errors.password.message}
                </div>
                <div>
                    <input
                        type="password"
                        autoComplete="off"
                        placeholder="Repeat password"
                        className="input input-bordered input-accent"
                        name="confirmPassword"
                        {...register("confirmPassword")}
                    />
                    {errors?.confirmPassword && errors.confirmPassword.message}
                </div>
                <button>Reset password</button>
            </form>
        </div>
    )
}
*/

const ResetPw = () => {
    let {id, code} = useParams();

    const navigate = useNavigate();

    const sendData = (texts) => {
        const body = JSON.stringify({
            id: id,
            code: code,
            pw: texts[0]
        });
        console.log(body);
        fetch(
            `${process.env.REACT_APP_USER_API_URL}/users/reset-pw`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: body
            }
        ).then(response => {
            if (response.ok) {
                navigate("/");
            }
        });
    }

    const inputs = [
        {
            name: "pw",
            isPassword: true,
            placeholder: "Select password",
            reqs: [
                "min 8",
                "upper",
                "lower",
                "num"
            ]
        }, {
            name: "pw2",
            isPassword: true,
            placeholder: "Repeat password",
            reqs: [
                "confirm pw"
            ]
        }
    ];

    return <div className="flex justify-center">
        <div className="flex flex-col w-1/6">
            <Form
                inputs={inputs}
                sendData={sendData}
            />
        </div>
    </div>
}

export default ResetPw;